import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconExclamation = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", focusable: false, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M11 5H13V14.99H11V5ZM11 16.997H13V19H11V16.997Z", clipRule: "evenodd" }) }));
const Memo = memo(SvgIconExclamation);
export default Memo;
//# sourceMappingURL=IconExclamation.js.map